import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './styles.css';

// Strict Mode stays on deliberately: it double-mounts in development, which is
// the cheapest possible detector for the Three.js resource leak in brief risk
// R-07. If the renderer's dispose path ever regresses, this surfaces it locally
// instead of at judging.
const root = document.getElementById('root');
if (!root) throw new Error('#root missing');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
